import React, { Component } from 'react';
import { Layout } from './Layout';

export class AboutMe extends Component {
    static displayName = AboutMe.name;

    render() {
        return (
            <Layout>
                <div>
                    <h1>Hello, world! </h1>
                    <p>My name is Hugo Ribeiro and welcome to my home application, built with ASP.NET MVC, React and BootStrap.</p>
                    <p>Full Stack Developer, Application Developer, Database Administrator, and Project Manager in a wide variety of business applications.
                        <br />Particularly interested in client/server and relational database design using MS-SQL Server and MySQL.
                        <br />Im always trying to be on the lead of new technologies and inovation.
                        <br />Other areas of interested are IOT.
                        Specialties: Team/Project management, Analist and Full Stack Developer.</p>
                    <p>Experience</p>
                    <ul>
                        <li>Been at Janela Digital for 19 years till now.
                            <br />I had multiple roles where that consiste in Junior Developer, Team Manager, Analist, Full Stack Developer and last Department Development Coordinator.
                            <br />Learn alot with the developers that were at the company and in skills of managing, microsoft, new development architectures and much more.
                        </li>
                        <li>
                            Altrantec for 2 years.
                            The primary objective was to build a fully automated billed system for comboios of portugal company.
                            <br />I was in charge of doing the analysis and requisits of the project in a team of four.
                            <br />Afterwards i was assigned to develop and maintain the SQL Databases to support the solution.
                        </li>  
                        <li>Infordesporto for 2 years.</li>
                        <li>Imadigito / BombaH for 2 years.</li>
                    </ul>
                    <p>Some links for you to know me better and which projects i have been envolved:</p>
                    <ul>
                        <li><a href='https://www.linkedin.com/in/hugoribas/' target='_blank' rel='noreferrer noopener'>Linkedin Profile</a></li>
                        <li><a href='https://egorealestate.com/' target='_blank' rel='noreferrer noopener'>eGO Realestate CRM</a></li>
                        <li><a href='https://supercasa.pt/' target='_blank' rel='noreferrer noopener'>Super Casa</a></li>
                        <li><a href='https://casasapo.pt/' target='_blank' rel='noreferrer noopener'>Casa Sapo</a></li>
                        <li><a href='https://infocasa.pt/' target='_blank' rel='noreferrer noopener'>Info Casa</a></li>
                    </ul>
                </div>
            </Layout>
        );
    }
}
